import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "absolute left-5 top-5 flex flex-col items-center" }

import { PropType } from 'vue';
import { ConnectFlowModelingActions, VueFlowNodeModel } from '@/types';
import store from '@/store';
import { PhoneMissedCallIcon } from '@heroicons/vue/solid';


export default /*@__PURE__*/_defineComponent({
  __name: 'HangUp',
  props: {
    node: {
        type: Object as PropType<VueFlowNodeModel>,
        required: true,
    },
},
  setup(__props) {

const props = __props;

function removeNode() {
    store.dispatch('flow/' + ConnectFlowModelingActions.DELETE_NODE, {
        nodeId: props.node.id,
        parentId: props.node.parentId,
    });
}

return (_ctx: any,_cache: any) => {
  const _component_UiNode = _resolveComponent("UiNode")!

  return (_openBlock(), _createBlock(_component_UiNode, {
    nodeId: __props.node.id,
    showActions: "",
    noEdition: "",
    onRemoveNode: removeNode,
    showHandleSource: false,
    hideNodeId: "",
    bgColor: "bg-gray-50",
    borderColor: "border-gray-300",
    roundedStyle: "rounded-2xl",
    padding: "p-0 pt-2 pr-2",
    nodeWidth: "w-24",
    nodeHeight: "h-20"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_unref(PhoneMissedCallIcon), { class: "mb-1 h-10 w-10 text-gray-600" })
      ])
    ]),
    _: 1
  }, 8, ["nodeId"]))
}
}

})